import React, { useState, useEffect } from 'react'
import { connect, useDispatch } from 'react-redux'

import { sortingTask } from 'features/admin/setting-config/actions'

import {
  userEmailSelector,
  serviceTokenSelector,
} from 'features/sensitive/sensitive.selector'

import RootState from 'typings/RootState'
import { RouteComponentProps } from 'react-router-dom'
import SubnavBar from 'Components/Shared/SubnavBar'
import { BreadcrumbLink } from 'Components/Shared/BreadCrumb/BreadCrumb'
import Menu from '../../MenuAdmin'
import { Row, Col, Drawer } from 'antd'
import styled from 'styled-components'
import { PaginationType } from 'features/types/common'
import Pagination from 'Components/Shared/Pagination'
import { initPagination } from 'utils/helper'
import { HeaderRow, TableColHeader } from 'Components/Shared/Table'
import PrimaryButton from 'Components/Shared/Button/PrimaryButton'
import moment, { Moment } from 'moment'
import DropdownPopupMenu from 'Components/Shared/Form/DropdownPopupMenu'
import MulticheckProject from 'Components/Shared/Filters/MulticheckProject'
import DropdownList from 'Components/Shared/Form/DropdownList'
import {
  AdminProject,
  AlertError,
  AlertSuccess,
  ConfirmDeleteModal,
  LoadingView,
} from 'Components/Shared'
import { translate } from 'i18n'
import TKeys from 'i18n/translationKey'
import { EventModal } from 'Components/Shared'
import RowItem from './RowItem'
import SettingVendorERCDetail from './Detail'
import {
  onCreateConfigurationERC,
  onGetConfigurationERC,
  onUpdateConfigurationERC,
} from 'features/admin/setting-config-erc/api'
import {
  ConfigERCListDetail,
  ConfigERCListDetailReq,
  GetDataListReq,
} from 'features/admin/setting-config-erc/types'
import {
  selectDataList,
  selectEvent,
  selectSorting,
} from 'features/admin/setting-vendor-erc/selector'
import { getActiveProjectList } from 'features/admin/project/api'
import { GetActiveProjectsReq } from 'features/admin/project/types'
import { selectActiveProjectList } from 'features/admin/project/selector'
import { SearchInput } from 'Components/Filter'
import {
  onGetConfigVendorList,
  onSaveVendorERC,
} from 'features/admin/setting-vendor-erc/api'
import {
  ConfigVendorERCDetailReq,
  ConfigVendorERCListDetail,
} from 'features/admin/setting-vendor-erc/types'
import { CompanyVandorItem, DataItem } from 'features/admin/user/types'
import UserBox from '../Position/Detail/UserBox'
type DefultProps = {
  homepage?: boolean
}

type Props = DefultProps & DispatchProps & RouteComponentProps & ReduxProps

const breadcrumbs: BreadcrumbLink[] = [
  {
    url: '/dashboard',
    title: 'Home',
    icon: '/home.png',
    active: true,
    showTitle: false,
  },
  {
    url: '/setting-vendor-erc',
    title: 'ตั้งค่าผู้รับเหมา ERC',
    active: false,
    showTitle: false,
  },
]

const SettingVendorERC: React.ComponentType<Props> = props => {
  const { UserEmail, token, event, dataList, sorting, projects } = props
  const [enableModal, setEnableModal] = useState(false)
  const [mode, setMode] = useState('')
  const [disPlayModal, setdisPlayModal] = useState(false)
  const [selectedItem, setSelectedItem] = useState({} as any)
  const [txtSearch, setTxtSearch] = useState('')
  const dispatch = useDispatch()
  const [pagination, setPagination] = useState<PaginationType>(initPagination())
  const [showModal, setshowModal] = useState(false)
  const [dataItem, setdataItem] = useState({} as any)

  useEffect(() => {
    onGetList()
  }, [pagination])

  const onGetList = () => {
    setEnableModal(true)
    const req: GetDataListReq = {
      UserEmail,
      Page: pagination.Page,
      RowPerPage: pagination.RowPerPage,
      TextFilter: txtSearch,
    }
    dispatch(onGetConfigVendorList(token, req))
  }

  const onCreate = () => {
    setSelectedItem({} as any)
    setdisPlayModal(true)
    setMode('create')
  }

  const onCloseDrawer = () => {
    setSelectedItem({})
    setdisPlayModal(false)
    setEnableModal(false)
  }

  const onSuccess = () => {
    onCloseDrawer()
    if (mode !== '') {
      setMode('')
      onGetList()
    }
  }

  const onSearch = (val: string) => {
    if (txtSearch === '' && val === '') return
    setTxtSearch(val)
    pagination.Page = 1
    setPagination({ ...pagination })
  }

  const onCreateConfig = () => {
    setEnableModal(true)
    const req: ConfigVendorERCDetailReq = {
      VendorCode: dataItem.VendorCode,
      VendorName: dataItem.VendorName,
      Active: true,
      UserEmail: UserEmail,
    }
    dispatch(onSaveVendorERC(token, req))
    setSelectedItem({} as any)
  }
  const onUpdateConfig = () => {
    setEnableModal(true)
    if (selectedItem.IsActive == 'A') {
      selectedItem.IsActive = 'N'
    } else {
      selectedItem.IsActive = 'A'
    }
    const req: ConfigVendorERCDetailReq = {
      ...selectedItem,
      Active: selectedItem.IsActive == 'A' ? true : false,
      UserEmail: UserEmail,
    }
    dispatch(onSaveVendorERC(token, req))
    setSelectedItem({} as any)
    setshowModal(false)
  }

  const onSort = (name: string) => {
    dispatch(sortingTask({ name }))
  }

  const onOpenConfirm = (item: ConfigVendorERCListDetail) => {
    setshowModal(true)
    setSelectedItem(item)
  }
  const onCloseModal = () => {
    setshowModal(false)
  }

  const content = dataList.List.map(
    (item: ConfigVendorERCListDetail, index: number) => {
      return (
        <RowItem key={index} item={item} onClick={() => onOpenConfirm(item)} />
      )
    }
  )

  return (
    <>
      <ConfirmDeleteModal
        title="ลบรายการ"
        desc={'คุณยืนยันต้องการลบผู้รับเหมารายนี้'}
        onClose={onCloseModal}
        onSubmit={onUpdateConfig}
        visible={showModal}
      />
      <SubnavBar
        breadcrumbs={breadcrumbs}
        hideSearch={true}
        adminSearchBox={<SearchInput onSearch={onSearch} />}
      />
      <EventModal
        name="defect"
        event={[event]}
        enable={enableModal}
        successCalback={onSuccess}
      />
      <Menu selected={'setting-vendor-erc'}>
        <MainPage>
          <Header>
            <Row type="flex" justify="space-between" align="top">
              <Col style={{ flex: 1 }}>ตั้งค่าผู้รับเหมา ERC</Col>

              <Col>
                <ButtonSection>
                  <PrimaryButton text="เพิ่มผู้รับเหมา" onClick={onCreate} />
                </ButtonSection>
              </Col>
            </Row>
          </Header>

          <HeaderRow
            onSort={name => onSort(name)}
            sorting={sorting}
            items={columnsName}
          />

          {content}

          <Pagination
            currentPage={pagination.Page}
            totalRows={dataList.Total}
            perPage={pagination.RowPerPage}
            onChangeNumber={(page: number) => {
              pagination.RowPerPage = page
              setPagination({ ...pagination })
            }}
            onClickPage={(page: number) => {
              pagination.Page = page
              setPagination({ ...pagination })
            }}
          />
        </MainPage>

        <Drawer
          title={null}
          className="drawer-project"
          closable={false}
          width={500}
          visible={disPlayModal}
        >
          <SettingVendorERCDetail
            item={selectedItem}
            UserEmail={UserEmail}
            token={token}
            onClose={onCloseDrawer}
            onSave={(user: CompanyVandorItem) => {
              dataItem.VendorCode = user.VendorCode
              dataItem.VendorName = user.VendorName
              onCreateConfig()
            }}
          />
        </Drawer>
      </Menu>
    </>
  )
}

const mapStateToProps = (state: RootState) => {
  return {
    event: selectEvent(state),
    token: serviceTokenSelector(state),
    UserEmail: userEmailSelector(state),
    dataList: selectDataList(state),
    sorting: selectSorting(state),
    projects: selectActiveProjectList(state),
  }
}

type ReduxProps = ReturnType<typeof mapStateToProps>

const mapDispatchToProps = {}

type DispatchProps = typeof mapDispatchToProps

const columnsName = [
  {
    title: 'รหัสผู้รับเหมา',
    span: 5,
    key: 'VendorCode',
  },
  {
    title: 'ชื่อผู้รับเหมา',
    span: 15,
    key: 'VendorName',
  },
  {
    title: 'เปิดการใช้งาน',
    span: 3,
    key: 'Action',
  },
]

const MainPage = styled.div`
  padding: 40px 45px;
  width: 100%;
`

const SaveArea = styled.div`
  margin-top: 32px;
  width: 160px;
`

const Box = styled.div`
  width: 380px;
`

const Header = styled.div`
  margin-bottom: 27px;
  font-size: 28px;
  line-height: 1.07;
  font-family: 'DB Helvethaica X 75 Bd';
  color: #000;
`

const Title = styled.h2`
  font-size: 28px;
  font-family: 'DB Helvethaica X 75 Bd';
  height: 30px;
`

const TitleSecond = styled.div`
  font-size: 20px;
  font-family: 'DB Helvethaica X 75 Bd';
  margin: 24px 0 8px 0;
  color: #000;
`

const ClearTxt = styled.div`
  font-family: 'DB Helvethaica X 75 Bd';
  color: #003168;
  font-size: 18px;
  text-decoration: underline;
  cursor: pointer;
`

const Text = styled.div`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  float: left;
  max-width: 70%;
`

const ButtonSection = styled.div`
  float: left;
  margin-left: 24px;
  width: 178px;
`

const DataArea = styled.div``

export default connect(mapStateToProps, mapDispatchToProps)(SettingVendorERC)
